import { Flex, Text } from '@chakra-ui/react';
import { ButtonText, Link } from '@morressier/alembic';

interface Props {
  pendingReviewCount?: number;
  createdEventsCount?: number;
  submittedResearchCount?: number;
  openCallsCount?: number;
  onScrollToReviewTasks?: () => void;
  onScrollToManageTasks?: () => void;
  onScrollToOpenCalls?: () => void;
}

const StatisticTiles = ({
  tile,
  width
}: {
  tile: {
    title: string;
    count: number;
    viewText: string;
    onViewClick?: () => void;
  };
  width: string;
}) => (
  <Flex
    direction="column"
    padding="1.5rem"
    gap="8px"
    backgroundColor="surfacePrimaryFill"
    width={width}
  >
    <Flex gap="8px" direction="column">
      <Text textStyle="headingOverline">{tile.title.toUpperCase()}</Text>
      <Text textStyle="textStatistics">{tile.count}</Text>
    </Flex>
    <ButtonText alignSelf="start" onClick={tile.onViewClick}>
      {tile.viewText}
    </ButtonText>
  </Flex>
);

const DashboardStatistics: React.FC<Props> = props => {
  const {
    pendingReviewCount,
    createdEventsCount,
    submittedResearchCount,
    openCallsCount,
    onScrollToManageTasks,
    onScrollToOpenCalls,
    onScrollToReviewTasks
  } = props;

  const TileMetadata = {
    PendingReviews: {
      title: 'Submissions to Review',
      count: pendingReviewCount || 0,
      viewText: 'View Your Reviews',
      onViewClick: onScrollToReviewTasks
    },
    CreatedEvents: {
      title: 'Created Events',
      count: createdEventsCount || 0,
      viewText: 'View Your Workflows',
      onViewClick: onScrollToManageTasks
    },
    ResearchSubmitted: {
      title: 'Research Submitted',
      count: submittedResearchCount || 0,
      viewText: 'View Your Submissions',
      onViewClick: () => {
        window.open('/submissions', '_blank');
      }
    },
    OpenCalls: {
      title: 'Open Calls',
      count: openCallsCount || 0,
      viewText: 'View All Calls',
      onViewClick: onScrollToOpenCalls
    }
  };

  const totalTiles = Object.values(TileMetadata).filter(
    t => t.count !== 0
  ).length;

  return (
    <Flex padding="2rem 0" gap="14px">
      {Object.values(TileMetadata).map(
        tile =>
          !!tile.count && (
            <StatisticTiles tile={tile} width={`${100 / totalTiles}%`} />
          )
      )}
    </Flex>
  );
};

export default DashboardStatistics;
